/* Uses Mode's cart refresh event and PARK's shared confirmation. */
(()=>{
  if(window.ParkPDPCart)return;
  let busy=false;
  window.ParkPDPCart={async add(items,{button,status}={}){
    if(busy)throw new Error(status?.dataset.busy||'');
    if(!Array.isArray(items)||!items.length)throw new Error(status?.dataset.empty||'');
    busy=true;const wasDisabled=button?.disabled;
    if(button){button.disabled=true;button.setAttribute('aria-busy','true');}
    if(status)status.textContent=status.dataset.loading||'';
    const controller=new AbortController();
    const timeout=setTimeout(()=>controller.abort(),10000);
    try{
      const response=await fetch(`${window.Shopify?.routes?.root||'/'}cart/add.js`,{
        method:'POST',signal:controller.signal,headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items,...window.ParkCartNotificationFlow?.sectionRequest()})
      });
      const result=await response.json();
      if(!response.ok||result.status>=400){const error=new Error(typeof result.description==='string'?result.description:status?.dataset.error);error.cartAPI=true;throw error;}
      if(window.ParkCartNotification)window.ParkCartNotification.show(result, items);
      document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged',{bubbles:true,detail:{openDrawer:!window.ParkCartNotification,cart:result}}));
      document.dispatchEvent(new CustomEvent('park-pdp:added',{detail:{items:result.items||[result]}}));
      if(status)status.textContent=status.dataset.success||'';
      if(!window.ParkCartNotification &&(window.theme?.settings?.after_add_to_cart==='page'||!document.querySelector('.cart-drawer')))location.assign(`${window.Shopify?.routes?.root||'/'}cart`);
      return result;
    }catch(error){
      // A lost response may still have added items. Never retry automatically.
      document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged',{bubbles:true,detail:{openDrawer:false}}));
      const message=error.cartAPI?error.message:status?.dataset.error||error.message;
      if(status)status.textContent=message;
      throw new Error(message);
    }finally{
      clearTimeout(timeout);busy=false;if(button){button.removeAttribute('aria-busy');button.disabled=wasDisabled;}
    }
  }};
})();
